var _slicedToArray = require("/tmp/build_c166955d/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _ = require('lodash');

// HANDLING RESOURCE/ENTRY OBJECT

var getFields = function getFields(resource) {
  return _.get(resource, 'fields') || {};
};
var getHasFields = function getHasFields(resource) {
  return !!_.get(resource, 'fields');
};
var getHeaderImage = function getHeaderImage(resource) {
  return getFields(resource).headerImage;
};
var getUrlName = function getUrlName(resource) {
  return getFields(resource).urlName;
};
var getExternalUrl = function getExternalUrl(resource) {
  return getFields(resource).externalUrl;
};
var getParentCategory = function getParentCategory(resource) {
  return getFields(resource).parentCategory;
};
var getSys = function getSys(resource) {
  return _.get(resource, 'sys') || {};
};
var getResourceId = function getResourceId(resource) {
  return getSys(resource).id;
};
var getResourceType = function getResourceType(resource) {
  return _.get(resource, 'sys.contentType.sys.id');
};
var getResourceName = function getResourceName(resource) {
  var resourceType = getResourceType(resource);
  var fields = getFields(resource);
  switch (resourceType) {
    case 'event':
      return fields.title || '';
    case 'news':
      return fields.title || '';
    case 'page':
      return fields.title || '';
    case 'promotion':
      return fields.title || '';
    case 'job':
      return fields.jobTitle || '';
    case 'retailUnit':
      return fields.name || '';
    default:
      return "";
  }
};
var getUrl = function getUrl(resource) {
  var resourceType = getResourceType(resource);
  var urlName = getUrlName(resource);
  var id = getResourceId(resource);
  var parentCategory = getParentCategory(resource);
  var externalUrl = getExternalUrl(resource);
  var parentCategoryLower = _.toLower(parentCategory);
  if (_.isUndefined(urlName) && _.isUndefined(id) && _.isUndefined(externalUrl)) {
    return '';
  }
  switch (resourceType) {
    case 'page':
      if (urlName) {
        return "/".concat(urlName);
      }
      return externalUrl;
    case 'event':
      return "/events/".concat(urlName);
    case 'promotion':
      var categoryType = _.get(resource, 'fields.categoryType');
      return "/".concat(convertCategoryTypeToUrl(categoryType), "/").concat(urlName);
    case 'job':
      return "/jobs/".concat(id);
    case 'retailUnitCategory':
      return "/".concat(_.kebabCase(parentCategoryLower === 'eatery' ? 'dine' : parentCategoryLower), "/").concat(urlName);
    case 'retailUnit':
      return "/".concat(_.kebabCase(parentCategoryLower === 'eatery' ? 'dine' : parentCategoryLower), "/").concat(urlName);
    default:
      return "/".concat(_.kebabCase(resourceType), "/").concat(urlName || id);
  }
};
var getEnableRegistrationLogIn = function getEnableRegistrationLogIn(center) {
  return _.get(center, 'fields.enableRegistrationLogIn', true);
};

// HANDLING REQUEST OBJECT

var getResources = function getResources(request) {
  return _.get(request, 'resources');
};
var getFirstResource = function getFirstResource(request) {
  return _.head(getResources(request));
};
var getFirstResourceFields = function getFirstResourceFields(request) {
  return _.flow([getFirstResource, getFields])(request);
};

// HANDLING ASSET OBJECT

var getAssetType = function getAssetType(assetObject) {
  return _.get(assetObject, 'fields.file.contentType');
};
var getAssetSrc = function getAssetSrc(assetObject, options) {
  var url = _.get(assetObject, 'fields.file.url');
  if (url) {
    url = "https:" + url;
    var _$split = _.split(getAssetType(assetObject), '/'),
      _$split2 = _slicedToArray(_$split, 2),
      type = _$split2[0],
      subtype = _$split2[1];
    var isImage = type === 'image';
    if (isImage) {
      var _ref = options || {},
        width = _ref.width,
        height = _ref.height,
        fit = _ref.fit;
      url += "?q=80";
      url += "&w=".concat(width || 800);
      if (height) url += "&h=".concat(height);
      if (fit) url += "&fit=".concat(fit);
      var isJpg = subtype === 'jpg' || subtype === 'jpeg';
      if (isJpg) url = url + '&fl=progressive';
    }
  }
  return url;
};
var getAssetTitle = function getAssetTitle(assetObject) {
  return _.get(assetObject, 'fields.title');
};
var convertCategoryTypeToUrl = function convertCategoryTypeToUrl(categoryType) {
  return {
    Competition: 'competitions',
    Offer: 'offers',
    Reward: 'rewards'
  }[categoryType];
};

// OTHER STUFF

var getEventDatesRange = function getEventDatesRange(_ref2) {
  var moment = _ref2.moment,
    from = _ref2.from,
    to = _ref2.to,
    _ref2$seperator = _ref2.seperator,
    seperator = _ref2$seperator === void 0 ? '-' : _ref2$seperator,
    _ref2$localeCode = _ref2.localeCode,
    localeCode = _ref2$localeCode === void 0 ? 'en-GB' : _ref2$localeCode;
  /**
   * Format Date to 'D MMM', if the date isn't valid return null.
   * @param {string} time Value to be formatted
   * @returns {string | null}
   */
  var validOrNull = function validOrNull(time) {
    return !!time && moment(time).isValid() ? moment(time).locale(localeCode).format('D MMM') : null;
  };
  var fromDate = validOrNull(from);
  var toDate = validOrNull(to);
  var isSameMonth = moment(from).format('M') === moment(to).format('M');
  var datetime = {
    from: moment(from).locale(localeCode).format('YYYY-MM-DD'),
    to: moment(to).locale(localeCode).format('YYYY-MM-DD')
  };
  var isSameDay = datetime.from === datetime.to;
  if (fromDate && toDate) {
    var dateData = {
      from: isSameDay && isSameMonth ? null : isSameMonth ? moment(from).locale(localeCode).format('D') : fromDate,
      to: toDate,
      seperator: isSameDay ? null : seperator,
      datetime: datetime
    };
    return dateData;
  } else {
    return null;
  }
};
var getEventDatesRangeString = function getEventDatesRangeString(_ref3) {
  var moment = _ref3.moment,
    from = _ref3.from,
    to = _ref3.to,
    _ref3$seperator = _ref3.seperator,
    seperator = _ref3$seperator === void 0 ? '-' : _ref3$seperator,
    localeCode = _ref3.localeCode;
  var dateRange = getEventDatesRange({
    moment: moment,
    from: from,
    to: to,
    seperator: seperator,
    localeCode: localeCode
  });
  if (dateRange) {
    return "".concat(dateRange.from ? dateRange.from : '').concat(dateRange.seperator ? " ".concat(dateRange.seperator, " ") : '').concat(dateRange.to);
  } else {
    return '';
  }
};
module.exports = {
  getFields: getFields,
  getHasFields: getHasFields,
  getHeaderImage: getHeaderImage,
  getUrlName: getUrlName,
  getParentCategory: getParentCategory,
  getSys: getSys,
  getResourceId: getResourceId,
  getResourceType: getResourceType,
  getResourceName: getResourceName,
  getUrl: getUrl,
  getResources: getResources,
  getFirstResource: getFirstResource,
  getFirstResourceFields: getFirstResourceFields,
  getAssetSrc: getAssetSrc,
  getAssetType: getAssetType,
  getAssetTitle: getAssetTitle,
  convertCategoryTypeToUrl: convertCategoryTypeToUrl,
  getEventDatesRange: getEventDatesRange,
  getEventDatesRangeString: getEventDatesRangeString,
  getEnableRegistrationLogIn: getEnableRegistrationLogIn
};